/* eslint-disable no-unused-vars */
import { Card,Typography,Button,CardContent,Grid, CardMedia} from '@mui/material'
import { AddShoppingCart } from '@material-ui/icons';
import React from 'react';
import useStyles from './styles';
import { formarttoPiCurrency } from '../../../utils/Utils';
import ReadMoreButton from '../ReadMoreButton';
import {useHistory} from 'react-router-dom';
import store_icon from '../../../assets/icons/online_store_96px.png';
import { myCld } from '../../../cloudinaryImage';
import CloudTranslate from '../../../translations/CloudTranslate';
import ProductLife from '../../products/product/ProductLife';
import { ContentCopy } from '@mui/icons-material';

/* 
import { EditorState , convertFromRaw} from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from 'draftjs-to-html';
import BasicRating from '../../rating/BasicRating' */

const ProductDetails = ({t,product,store,onAddToCart,langcode,size,setSize,browser}) => {
    const classes =useStyles();
    const history = useHistory()
    const [iscopied,setIscopied]=React.useState(false)
    const [productUrl,setProductUrl]=React.useState()


    React.useEffect(() => {
        if (!productUrl && store.tag && product._id) {
            const url = `${process.env.REACT_APP_WEBSITE_URL}/s/${store.tag}/${product._id}`;
            setProductUrl(url);
        }
    }, [product._id, productUrl, store])

    const ShareProductUrl = ({storeUrl}) =>{
            return (
               <Grid item>
              { productUrl ? <Grid container justifyContent={'space-between'} alignItems={'center'} alignContent={'center'}>
                           
                     <Grid item xs={1} >
                   {iscopied ? <ContentCopy color='primary' sx={{transform:'scale(0.6)'}} onClick={() => { navigator.clipboard.writeText(`${productUrl}`);setIscopied(true)}}/>: <ContentCopy color='textGrey' sx={{transform:'scale(0.6)'}} onClick={() => { navigator.clipboard.writeText(`${productUrl}`);setIscopied(true)}}/>}
                   
                  </Grid> 
                 {/*  <Grid item xs={11}>
              <Typography fontSize='0.7rem' overflow={true}>{`${storeUrl}`}</Typography>
              </Grid> */}
                  </Grid>:''}
              </Grid>
              
            )
          }
    const buynow = (product,qty,action) => {
      if (process.env.NODE_ENV === 'development') {
        onAddToCart(product,qty,action)
       
      }else{

      
     try {

       const browserlist = ['ios-webview','chromium-webview']

    if(!browserlist.includes(browser.name)) {
      // If the browser is not in the list, redirect to the Pinet URL
      console.log('Browser not supported for direct buy now, redirecting to Pinet URL');
      const productUrl = `${process.env.REACT_APP_CLIENT_PINET_URL}/s/${store.tag}/${product._id}`;
      console.log(productUrl);
      window.location.href = productUrl
 }else{
     onAddToCart(product,qty,action)
   }
    
      } catch (error) {
        console.log(error)
      }
    }
  }
    const onGridSizeItemClick=(item)=>{
      setSize(item)
      console.log(item) 
      console.log(size)  
 }
    const SizeGridList= ({list ,onUpdateColorSize}) =>(
                    
           <Grid container  justifyContent={'space-between'} spacing={2} marginTop={2}>  
            {list.map((item,index)=>(
             item!==''? <Grid item key={index} /* className={`${classes.gridSpecsItem} ${size===item ? classes.select:classes.disSelect}`} */ onClick={()=>{/* onUpdateColorSize(cartitem.product._id,'size',item) */;onGridSizeItemClick(item)}}><Button variant={ size ===item ? 'outlined':'standard'}>{item}</Button></Grid>: ''
            ))}
           
           </Grid>)
  return (
    <Grid container justifyContent={'space-between'} className={classes.root} >
    
     {
        product.name!==undefined ?   <Grid item xs={12}>
          
         <Grid container className={classes.cntentSub}>
          
         { store ? <Grid item xs={12}>
             <Grid container justifyContent={'flex-start'} spacing={0} padding={0} alignItems='center'>
          <Grid item xs={2}>
          {  store.image ? <CardMedia className={classes.storeimg} image={myCld.image(`${store.image.public_id}`).format('auto').quality('auto').addFlag('lossy').toURL()}/> : <CardMedia className={classes.storeimg} image={store_icon}/>}
          </Grid>
          <Grid item xs={10}paddingTop={2} marginLeft={-2} marginBottom={2}>
            <Grid container justifyContent={'space-between'} >

              <Grid item >
   <Button variant='text' color='primary' onClick={()=>{history.push(`/store?storeId=${store._id}`)}}> {<CloudTranslate langcode={langcode} t={t}text={store.name}/>}</Button>
                </Grid>
                 <Grid item > 
          <ShareProductUrl productUrl={productUrl}/>
          </Grid>
              </Grid>
       
          </Grid>
         
        </Grid>
  </Grid>:'' }
  
    <Grid item xs={12}>
    <Grid container justifyContent={'space-between'}  alignItems={'center'} spacing={1} >
              
              <Grid item xs={9}>
              <Typography variant="body1" color='darkgray' width={'100%'} noWrap={true}>
                    { <CloudTranslate t={t} text={product.name} langcode={langcode}/>}
                </Typography>
              </Grid>
              <Grid item xs={3}  >
               <Grid container justifyContent={'flex-end'}>
                      <Grid item marginTop={-1.5}>
                      {product ? <ProductLife product={product} variant={'outlined'}/> :''} 
                      </Grid>
               </Grid>
              </Grid>
            </Grid>
    </Grid>

       <Grid item xs={12}>
       <Grid container justifyContent='space-between' marginTop={1}>
            <Grid item >
           <Typography variant="h6" sx={{fontSize:'1rem'}}  className={classes.price}>
              {formarttoPiCurrency(product.price)}
          </Typography>
           </Grid>
            <Grid item >
            <Typography variant="span"  sx={{fontSize:'0.9rem'}} className={classes.stock}>
              {`${t("form.product.stock.label")} ${product.stock.currentstock >=1 ? product.stock.currentstock :0} `}
          </Typography>
            </Grid>
       </Grid>
       </Grid>

        <Grid item xs={12}>
        <Grid container justifyContent={'space-between'} direction='column' alignItems={'flex-start'} spacing={1}>
            {/*   <Grid item >
              <SizeGridList list={product.size} />
              </Grid> */}
              <Grid item >
             {/*  <div  style={{fontSize:'0.8rem',minHeight:'30vh',overflow:'scroll'}}   dangerouslySetInnerHTML={{ __html: truncateString(product.description,300) }}/>  */}

              <ReadMoreButton langcode={langcode} t={t} content={product.description} maxLength={300} />
              
             
              </Grid>
              <Grid item>
          {
            product.shippingDuration ? (
             <Grid container justifyContent={'space-between'}>
               <Grid item>
               <Typography style={{fontSize:'0.8rem',color:'darkgray'}}>
                            Estimated Delivery: 
                        </Typography>
                </Grid >

                <Grid item>
                <Typography style={{fontSize:'0.8rem'}}>{product.shippingDuration.value} {product.shippingDuration.unit}</Typography>
                  </Grid>
             </Grid>
                    ) : (
                          <Typography style={{fontSize:'0.8rem',color:'darkgray'}}>
                            No delivery time set.
                        </Typography>
                    )}
          </Grid>
            {product.shippingArea ?  <Grid item xs={12} >
               <Grid container  spacing={1}>
                  <Grid item >
                  <Typography style={{fontSize:'0.8rem',marginTop:'5px',color:'darkgray'}}>
       { t('form.product.shippingarea.label') }
       </Typography>
               </Grid>

               <Grid item >
               <Typography style={{fontSize:'0.8rem',marginTop:'5px'}}>
       { product.shippingArea }
       </Typography>
               </Grid>
               </Grid>
              </Grid> :''}
         </Grid>
        </Grid>
      {/* <BasicRating title={'Product Rate'} ratedValue={0}/>
 */}         </Grid>
      
        
          <Grid item xs={12}  >
              <Grid container justifyContent={'center'} alignItems={'center'} >
                <Grid item xs={12}    marginTop={4}>
                <Button sx={{textTransform:'none',borderRadius:'30px',padding:'10px 5px'}} fullWidth  /* 'client-action-Button'  type="submit"*/  variant="contained" color="primary" onClick={()=>{buynow(product,0,"buynow")}}>{t("proceedcheckout.buynow")/* Add to  Cart <AddShoppingCart/>  */} 
          </Button>
                </Grid>
              </Grid>
          
          </Grid>
        

       </Grid>:''
      }
     </Grid>
  )
}

export default ProductDetails
